<template>
    <div id="content" class="container-medium az-page">
    <div class="row">
      <div class="col-xs-12 col-sm-6 col-sm-offset-3">
          <div class="select item full-width">
              <select v-model=selectedCountry v-on:change="selectChange">
                  <option v-for="country in countries"
                    :value="country[0]"
                    >
                    {{ country[1] }}
                  </option>
              </select>
              <span class="icon-angle-down"></span>
          </div>
      </div>

      <div class="col-xs-12">
        <ul>
          <div v-for="(items, locality) in countryAZ" class="locality-block">
            <h1 class="text-medium text-gray">{{ locality }}</h1>
            <li v-for="item in items">
              <router-link class="swimspot" :to="{ name: 'slug', params: { slug: item.slug }}">{{ item['name'] }}</router-link>
            </li>
          </div>
          <div v-if="countryAZ.length == 0" class="locality-block">
            <h1 class="text-medium text-gray">All swimspots by country</h1>
            <li v-for="country in countries" v-if="country[0] != 'select'">
              <router-link :to="{ name: 'az', params: { country: country[0] }}">{{ country[1] }}</router-link>
            </li>
          </div>
        </ul>
      </div>
    </div>
    </div>
</template>

<script>

export default {
  data: function () {
    return {
      countryAZ: [],
      selectedCountry: '',
      countries: [["select", "Select Country"], ["ie", "Ireland"], ["pt", "Portugal"], ["es", "Spain"]], // needs manual update..
    }
  },
  mounted: function () {
    var country = null
    if (this.$route.params.country !== undefined) {
      country = this.$route.params.country
    }
    // direct hit on page, need to wait for root instance
    eventBus.$on('rootReady',() => {
      if (country) {
        this.countryAZ = App.getCountryAZ(country)
      }
      this.updateSelect(country)
      this.rootReady = true
    })
    //routed from another component so route instance instantiated
    if (typeof App != 'undefined') {
      this.updateAZ(country)
    }
  },
  watch: {
      '$route': function() {
        var country = null
        if (this.$route.params.country !== undefined) {
          country = this.$route.params.country
        }
        this.updateAZ(country)
      },
  },
  methods: {
    selectChange: function(event) {
      if (event.target.value == "select") {
        this.$router.push('/a-z/')
      } else if (event.target.value != null) {
        this.$router.push('/a-z/' + event.target.value + '/')
      }
    },
    updateAZ: function(country) {
      App.showLoading()
      var vm = this
      var url = '/praias/a-z/'
      if (country) {
        url = '/praias/a-z/' + country + '/'
        vm.countryAZ = App.getCountryAZ(country)
      }
      this.updateSelect(country)
      App.hideLoading()
    },
    updateSelect: function(country) {
      var vm = this
      if (country == null) {
          this.selectedCountry = 'select'
          this.countryAZ = []
      } else {
        this.selectedCountry = country
      }
    },
  }
}

</script>

